import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import { Button, ButtonGroup } from '@material-ui/core';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
import RegistrationGuideKr from './RegistrationGuideKr';
import RegistrationGuideEn from './RegistrationGuideEn';

class RegistrationGuide extends React.Component {
  constructor(props) {
    super(props);
    // console.log(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
      tabValue: 0,
      isTest: false, //props.match.path === '/registration/guide_test',
    };
  }

  componentDidMount() {}

  handleState(key, value) {
    this.setState({ [key]: value });
  }

  cancellationFormDownload = () => {
    window.open('https://innon.s3.ap-northeast-2.amazonaws.com/PRS2021/registration/PRS+KOREA+2021_Cancellation_Form+(1).docx', '_blank');
  };

  render() {
    const { tabValue } = this.state;
    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={3} SIdx={0} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={8}>
              <MainTitle>Guidelines</MainTitle>
            </Grid>
            <Grid item xs={8}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <ButtonGroup color="primary" fullWidth disableElevation style={{ width: '80%' }}>
                  <Button
                    variant={tabValue === 0 ? 'contained' : 'outlined'}
                    onClick={() => this.handleState('tabValue', 0)}
                    style={{ fontSize: 'large' }}
                  >
                    Korean
                  </Button>
                  <Button
                    variant={tabValue === 1 ? 'contained' : 'outlined'}
                    onClick={() => this.handleState('tabValue', 1)}
                    style={{ fontSize: 'large' }}
                  >
                    English
                  </Button>
                </ButtonGroup>
              </div>
            </Grid>
            <Grid item xs={8}>
              <div style={{ margin: '3em 0' }}>
                {tabValue === 0 ? (
                  <RegistrationGuideKr cancellationFormDownload={this.cancellationFormDownload.bind(this)} parent={this.props} />
                ) : null}
                {tabValue === 1 ? (
                  <RegistrationGuideEn cancellationFormDownload={this.cancellationFormDownload.bind(this)} parent={this.props} />
                ) : null}
              </div>
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default RegistrationGuide;
